import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import * as Yup from "yup";
import { getBranchAirport, getBranchCity, getBranchCountry, getBranchDetail, getBranchMoreAddressDetail, getBranchMoreAddressList, getBranchSeaport, getBranchState } from '../../../../../Redux/action/Organisation/Branch/BranchAction';
import { adminMainUrl } from '../../../../../Config';
import axios from 'axios';
import Cookies from "js-cookie";
import { toast } from 'react-toastify';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import Swal from 'sweetalert2';
import AddMoreAddressess from './MoreAddressessOffCanvas/AddMoreAddressess';
import EditMoreAddressess from './MoreAddressessOffCanvas/EditMoreAddressess';

const MoreAddresses = ({ branch_id, token, user_id, b64id, refresh, branch_country_id }) => {
    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [more_address_list, set_more_address_list] = useState([]);
    const [more_address_id, set_more_address_id] = useState(0);

    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => setShowAdd(false);
    const handleShowAdd = () => setShowAdd(true);

    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = () => setShowEdit(true);


    const handleEditMoreAddress = (id) => {
        if (id) {
            set_more_address_id(id);
            handleShowEdit();
        }
    }

    useEffect(() => {
        if (branch_id && b64id) {
            set_more_address_list([]);
            let customer_id = atob(b64id);
            if (customer_id) {
                dispatch(getBranchMoreAddressList(token, user_id, branch_id, customer_id));
            }
        }
        if (branch_country_id) {
            handleGetState(Number(branch_country_id));
        }
    }, [branch_id, b64id, branch_country_id]);

    const refreshMoreAddress = () => {
        if (branch_id && b64id) {
            let customer_id = atob(b64id);
            if (customer_id) {
                dispatch(getBranchMoreAddressList(token, user_id, branch_id, customer_id));
            }
        }
        if (branch_country_id) {
            handleGetState(Number(branch_country_id));
        }
    }

    //delete  a more address
    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to delete this item?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let values = { id: id }
                    let config = { headers: { "auth-token": token, 'user_id': user_id } }
                    return axios.post(`${adminMainUrl}/api/organization/general/branch/address/delete`, values, config);
                } else {
                    throw new Error("Deletion canceled");
                }
            })
            .then((response) => {
                Swal.fire("Deleted!", "Your item has been deleted.", "success");
                refreshMoreAddress();
            })
            .catch((error) => {
                if (error.message === "Deletion canceled") {
                    Swal.fire("Cancelled", "Your item is safe.", "info");
                } else {
                    Swal.fire("Error!", error.response?.data?.message || "Something went wrong.", "error");
                }
            });
    };

    const {
        loadingBranchCountryApi,
        BranchCountryDataError,
        BranchCountryData,

        //state
        loadingBranchStateApi,
        BranchStateDataError,
        BranchStateData,

        //city
        loadingBranchCityApi,
        BranchCityDataError,
        BranchCityData,

        //Address list
        loadingBranchMoreAddressList,
        BranchMoreAddressListError,
        BranchMoreAddressList,


        //addrrss view
        loadingBranchMoreAddressDetail,
        BranchMoreAddressDetailError,
        BranchMoreAddressDetail,
    } = useSelector(state => state?.BranchReducer);




    const initialValues = {
        customer_id: "",
        general_branch_id: "",
        type: "",
        name: "",
        address_line_one: "",
        address_line_two: "",
        address_line_three: "",
        city: "",
        postal_code: "",
        state: "",
        telephone: "",
        fax: "",
        email_address: ""
    };




    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({}),
        onSubmit: (values, { resetForm }) => {
            values.customer_id = atob(b64id);
            setDisableSubmit(true);

            try {
                const config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                let url = `${adminMainUrl}/api/organization/general/branch/address/add`;
                if (more_address_id) {
                    url = `${adminMainUrl}/api/organization/general/branch/address/update`;
                    values.id = more_address_id;
                }
                if (branch_id == 0) {
                    toast.error("Branch not found!");
                    return;
                } else {
                    values.general_branch_id = Number(branch_id);
                }

                axios.post(url, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            setDisableSubmit(false);
                            refreshMoreAddress();
                            resetForm();
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal server error."
                        if (error.response) {
                            if (error.response.data) {
                                if (error.response.data.msg) {
                                    msg = error.response.data.msg
                                }
                            }
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    });
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });



    // address id based selection
    // if 0 -> reset form to add new entries.
    // if !=0 -> use dispatch to set details to edit form

    useEffect(() => {

        if (more_address_id == 0) {
            formik.resetForm();
        } else {
            if (token && user_id && branch_id && b64id) {
                let customer_id = atob(b64id);
                if (customer_id) {
                    dispatch(getBranchMoreAddressDetail(token, user_id, customer_id, branch_id, more_address_id));
                }
            }
        }
    }, [more_address_id]);


    useEffect(() => {
        if (more_address_id == 0) {
            formik.setFieldValue("general_branch_id", "");
            formik.setFieldValue("type", "");
            formik.setFieldValue("name", "");
            formik.setFieldValue("address_line_one", "");
            formik.setFieldValue("address_line_two", "");
            formik.setFieldValue("address_line_three", "");
            formik.setFieldValue("city", "");
            formik.setFieldValue("postal_code", "");
            formik.setFieldValue("state", "");
            formik.setFieldValue("telephone", "");
            formik.setFieldValue("fax", "");
            formik.setFieldValue("email_address", "");
        } else {
            if (BranchMoreAddressDetail) {
                // console.log(BranchMoreAddressDetail);

                if (BranchMoreAddressDetail?.state) {
                    handleGetCity(Number(BranchMoreAddressDetail?.state));
                }
                formik.setFieldValue("general_branch_id", BranchMoreAddressDetail?.general_branch_id);
                formik.setFieldValue("type", BranchMoreAddressDetail?.type);
                formik.setFieldValue("name", BranchMoreAddressDetail?.name);
                formik.setFieldValue("address_line_one", BranchMoreAddressDetail?.address_line_one);
                formik.setFieldValue("address_line_two", BranchMoreAddressDetail?.address_line_two);
                formik.setFieldValue("address_line_three", BranchMoreAddressDetail?.address_line_three);
                formik.setFieldValue("city", Number(BranchMoreAddressDetail?.city));
                formik.setFieldValue("postal_code", BranchMoreAddressDetail?.postal_code);
                formik.setFieldValue("state", Number(BranchMoreAddressDetail?.state));
                formik.setFieldValue("telephone", BranchMoreAddressDetail?.telephone);
                formik.setFieldValue("fax", BranchMoreAddressDetail?.fax);
                formik.setFieldValue("email_address", BranchMoreAddressDetail?.email_address);
            }
        }

    }, [loadingBranchMoreAddressDetail, BranchMoreAddressDetailError, BranchMoreAddressDetail])

    useEffect(() => {

        if (loadingBranchMoreAddressList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }

        if (BranchMoreAddressList) {
            set_more_address_list(BranchMoreAddressList);
        }

    }, [branch_id, loadingBranchMoreAddressList, BranchMoreAddressListError, BranchMoreAddressList,])



    //state
    const handleGetState = (id) => {
        try {
            if (id) {
                dispatch(getBranchState(id));
            }
        } catch (error) {
            console.log("Error in handleGetState function:", error.message);
        }
    };

    const [stateOptions, setStateOptions] = useState([]);
    const [loadState, setLoadState] = useState(false);
    useEffect(() => {
        if (loadingBranchStateApi) {
            setLoadState(true);
        } else {
            setLoadState(false);
        }

        if (BranchStateData) {
            let arr = [];
            BranchStateData.map(val => { arr.push({ value: val.id, label: val.name }) });
            setStateOptions(arr);
        }

    }, [loadingBranchStateApi, BranchStateDataError, BranchStateData]);


    //city
    const handleGetCity = (id) => {
        try {
            if (id) {
                dispatch(getBranchCity(id));
            }
        } catch (error) {
            console.log("Error in handleGetCity function:", error.message);
        }
    };

    const [cityOptions, setCityOptions] = useState([]);
    const [loadCity, setLoadCity] = useState(false);
    
    useEffect(() => {
        if (loadingBranchCityApi) {
            setLoadCity(true);
        } else {
            setLoadCity(false);
        }

        if (BranchCityData) {
            let arr = [];
            BranchCityData.map(val => { arr.push({ value: val.id, label: val.name }) });
            setCityOptions(arr);
        }

    }, [loadingBranchCityApi, BranchCityDataError, BranchCityData]);




    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <h2 className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark accordion-header">
                            <button type="button" aria-expanded="true" className="accordion-button">
                                {" "}
                                <span className="avatar avatar-md rounded text-dark border me-2">
                                    <i className="ti ti-user-plus fs-20" />
                                </span>
                                More Addresses
                            </button>
                        </h2>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="row d-flex jusfify-content-end">
                                    <div className="d-flex justify-content-end mt-2">
                                        <button className="btn btn-sm btn-danger" type="button"
                                            // onClick={() => { set_more_address_id(0) }}
                                            onClick={() => { handleShowAdd(true) }}
                                        >+Add</button>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover table-sm">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Type</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {more_address_list.map((val, index) => {
                                                return <tr className={`org-gen-more-add-trow ${val.id == more_address_id ? "active" : ""}`}>
                                                    <td scope="row">{index + 1}</td>
                                                    <td>{val?.type}</td>
                                                    <td>{val?.name}</td>
                                                    <td>
                                                        <div className="d-flex">
                                                            <button className="btn btn-sm btn-outline-primary me-1" title='Edit'
                                                                // onClick={() => { set_more_address_id(val?.id) }}
                                                                onClick={() => { handleEditMoreAddress(val.id) }}
                                                            >
                                                                <i className="fa-solid fa-pen-to-square" ></i></button>
                                                            <button className="btn btn-sm btn-outline-danger" title='Delete' onClick={() => { handleDelete(val.id) }}><i className="fa-solid fa-trash" ></i></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* <div className="col-md-6">
                                <div className="card">
                                    <div className="car-body p-2">
                                        <div className="row">
                                            <div className="col-12">
                                                <h6 className='text-label-red'>Add More Address</h6>
                                            </div>
                                            <form onSubmit={formik.handleSubmit}>
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                            <label htmlFor="postal_code" className="form-label mb-0 text-label-red">
                                                                Type
                                                            </label>
                                                        </div>
                                                        <select
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="name"
                                                            name="type"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.type}
                                                        >
                                                            <option value="">-Select a type-</option>
                                                            <option value="Delivery">Delivery</option>
                                                            <option value="Factory">Factory</option>
                                                            <option value="Pickup">Pickup</option>
                                                            <option value="Warehouse">Warehouse</option>

                                                        </select>

                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                            <label htmlFor="name" className="form-label mb-0 text-label-red">
                                                                Name
                                                            </label>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="name"
                                                            placeholder="Enter Name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                            <label htmlFor="address_line_one" className="form-label mb-0 text-label-red">
                                                                Address
                                                            </label>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="address_line_one"
                                                            placeholder="Address line 1"
                                                            name="address_line_one"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.address_line_one}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="address_line_two"
                                                            placeholder="Address line 2"
                                                            name="address_line_two"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.address_line_two}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="address_line_three"
                                                            placeholder="Address line 3"
                                                            name="address_line_three"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.address_line_three}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                            <label htmlFor="state" className="form-label mb-0 text-label-red">
                                                                State
                                                            </label>
                                                        </div>
                                                        <Select
                                                            className='custom-selector'
                                                            options={stateOptions}
                                                            id="state"
                                                            name="state"
                                                            value={stateOptions.find(option => option.value === formik.values.state)}
                                                            onChange={option => { formik.setFieldValue('state', option.value); handleGetCity(option.value); formik.setFieldValue('city', ''); }}
                                                            onBlur={formik.handleBlur}
                                                            isLoading={loadState}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                            <label htmlFor="address_line_one" className="form-label mb-0 text-label-red">
                                                                City
                                                            </label>
                                                        </div>
                                                        <Select
                                                            className='custom-selector'
                                                            options={cityOptions}
                                                            name="city"
                                                            value={cityOptions.find(option => option.value === formik.values.city)}
                                                            onChange={option => formik.setFieldValue('city', option.value)}
                                                            onBlur={formik.handleBlur}
                                                            isLoading={loadCity}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                            <label htmlFor="postal_code" className="form-label mb-0 text-label-red">
                                                                Postal Code
                                                            </label>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="postal_code"
                                                            placeholder="Enter Postal Code"
                                                            name="postal_code"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.postal_code}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                            <label htmlFor="telephone" className="form-label mb-0 text-label-red">
                                                                Telephone
                                                            </label>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="telephone"
                                                            placeholder="Enter Telephone No."
                                                            name="telephone"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.telephone}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                            <label htmlFor="fax" className="form-label mb-0 text-label-red">
                                                                Fax
                                                            </label>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="fax"
                                                            placeholder="Enter FAX No."
                                                            name="fax"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.fax}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <div className=" mb-1 d-flex justify-content-between align-items-center">
                                                            <label htmlFor="email_address" className="form-label mb-0 text-label-red">
                                                                Email Address
                                                            </label>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            id="email_address"
                                                            placeholder="Enter Email Address"
                                                            name="email_address"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.email_address}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="d-flex flex-wrap gap-2">
                                                    </div>
                                                    <button className="btn btn-sm btn-danger" type='submit' disabled={disableSubmit} >
                                                        {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : `${more_address_id ? "Update" : "Add"} Address`}
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                            </div> */}
                        </div>


                        {/* Add Modal */}
                        <AddMoreAddressess
                            branch_id={branch_id}
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            refresh={refresh}
                            branch_country_id={branch_country_id}

                            show={showAdd}
                            handleClose={handleCloseAdd}

                            //state
                            loadingBranchStateApi={loadingBranchStateApi}
                            BranchStateDataError={BranchStateDataError}
                            BranchStateData={BranchStateData}

                            //city
                            loadingBranchCityApi={loadingBranchCityApi}
                            BranchCityDataError={BranchCityDataError}
                            BranchCityData={BranchCityData}

                            //Address list
                            loadingBranchMoreAddressList={loadingBranchMoreAddressList}
                            BranchMoreAddressListError={BranchMoreAddressListError}
                            BranchMoreAddressList={BranchMoreAddressList}


                            //addrrss view
                            loadingBranchMoreAddressDetail={loadingBranchMoreAddressDetail}
                            BranchMoreAddressDetailError={BranchMoreAddressDetailError}
                            BranchMoreAddressDetail={BranchMoreAddressDetail}

                            handleGetCity={handleGetCity}
                            refreshMoreAddress={refreshMoreAddress}


                            loadState={loadState}
                            loadCity={loadCity}
                            stateOptions={stateOptions}
                            cityOptions={cityOptions}

                        />
                        <EditMoreAddressess
                            branch_id={branch_id}
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                            refresh={refresh}
                            branch_country_id={branch_country_id}

                            show={showEdit}
                            handleClose={handleCloseEdit}

                            //state
                            loadingBranchStateApi={loadingBranchStateApi}
                            BranchStateDataError={BranchStateDataError}
                            BranchStateData={BranchStateData}

                            //city
                            loadingBranchCityApi={loadingBranchCityApi}
                            BranchCityDataError={BranchCityDataError}
                            BranchCityData={BranchCityData}

                            //Address list
                            loadingBranchMoreAddressList={loadingBranchMoreAddressList}
                            BranchMoreAddressListError={BranchMoreAddressListError}
                            BranchMoreAddressList={BranchMoreAddressList}


                            //addrrss view
                            loadingBranchMoreAddressDetail={loadingBranchMoreAddressDetail}
                            BranchMoreAddressDetailError={BranchMoreAddressDetailError}
                            BranchMoreAddressDetail={BranchMoreAddressDetail}

                            handleGetCity={handleGetCity}
                            refreshMoreAddress={refreshMoreAddress}


                            loadState={loadState}
                            loadCity={loadCity}
                            stateOptions={stateOptions}
                            cityOptions={cityOptions}

                            more_address_id={more_address_id}

                        />
                    </>
            }
        </>
    )
}

export default MoreAddresses